import type { PayloadAction } from '@reduxjs/toolkit'
import { createSlice } from '@reduxjs/toolkit'
import type { Development, FilterType } from '@homeviews/models'

export const DEVELOPMENTS_FEATURE_KEY = 'developments'

type DevelopmentsState = {
  developments: Development[]
  filters: any
}

const initialDevelopmentsState: DevelopmentsState = {
  developments: [],
  filters: {},
}

export const developmentsSlice = createSlice({
  name: DEVELOPMENTS_FEATURE_KEY,
  initialState: initialDevelopmentsState,
  reducers: {
    setDevelopments: (
      state,
      {
        payload: { developments },
      }: PayloadAction<{ developments: Development[] }>,
    ) => {
      state.developments = developments
    },
    setDevelopmentsFilter: (
      state,
      {
        payload: { filter, value },
      }: PayloadAction<{ filter: FilterType; value: any }>,
    ) => {
      const currentFilters = state.filters
      if (!value) {
        delete currentFilters[filter]
        state.filters = {
          ...currentFilters,
        }
      } else {
        state.filters = {
          ...state.filters,
          page: 1,
          [filter]: value,
        }
      }
    },
    clearDevelopmentsFilters: (state) => {
      const newFilters: any = {}
      if (state.filters?.posts_per_page) {
        newFilters.posts_per_page = state.filters.posts_per_page
      }
      state.filters = newFilters
    },
  },
})

/*
 * Export reducer for store configuration.
 */
export const developmentsReducer = developmentsSlice.reducer

export const { setDevelopmentsFilter, clearDevelopmentsFilters } =
  developmentsSlice.actions

export const getDevelopmentsState = (rootState: unknown): DevelopmentsState =>
  rootState[DEVELOPMENTS_FEATURE_KEY]

export const selectDevelopmentsFilters = (rootState: unknown) =>
  rootState[DEVELOPMENTS_FEATURE_KEY]?.filters
